import {Component, inject, OnInit} from '@angular/core';
import {FooterComponent} from "../../../common/footer/footer.component";
import {FormControl, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {HeaderComponent} from "../../../common/header/header.component";

import {LocaleService} from "../../../../locale/locale.service";
import {FormNavigationService} from "../../../../services/form-navigation/form-navigation.service";
import { NavigationKey } from '../../../../enums/navigation-key-type';
import {InvolvedVehicleType} from "../../../../enums/involved-vehicle-type";
import {ClaimsService} from "../../../../services/claims.service";

@Component({
  selector: 'app-vehicle-involved',
  imports: [
    FooterComponent,
    FormsModule,
    HeaderComponent,
    ReactiveFormsModule
  ],
  templateUrl: './vehicle-involved.component.html',
  styleUrl: './vehicle-involved.component.css'
})
export class VehicleInvolvedComponent implements OnInit {
  locale = inject(LocaleService);
  private formNavigationService = inject(FormNavigationService);
  private claimService = inject(ClaimsService);

  showError: boolean = false;
  options: { headline: string, caption: string, value: string }[] = [];
  radioControl = new FormControl();

  constructor() {
    this.options = [
      {
        headline: this.locale.currentTranslation.vehicleInvolvedOptionHeadline1,
        caption: this.locale.currentTranslation.vehicleInvolvedOptionCaption1,
        value: InvolvedVehicleType.FourWheelsWithEngine
      },
      {
        headline: this.locale.currentTranslation.vehicleInvolvedOptionHeadline2,
        caption: this.locale.currentTranslation.vehicleInvolvedOptionCaption2,
        value: InvolvedVehicleType.TwoWheelsWithEngine
      },
      {
        headline: this.locale.currentTranslation.vehicleInvolvedOptionHeadline3,
        caption: this.locale.currentTranslation.vehicleInvolvedOptionCaption3,
        value: InvolvedVehicleType.TwoWheelsWithNoEngine
      },
      {
        headline: this.locale.currentTranslation.vehicleInvolvedOptionHeadline4,
        caption: this.locale.currentTranslation.vehicleInvolvedOptionCaption4,
        value: InvolvedVehicleType.None
      }
    ]
  }

  ngOnInit(): void {
    this.claimService.getData().subscribe(() => {
      if (this.claimService.claimReport()?.vehicleType) {
        this.radioControl = new FormControl(this.claimService.claimReport().vehicleType);
      }
    })
  }

  nextClicked() {
    this.evaluateShowError()
    const rawValue = this.radioControl.getRawValue();
    if (!this.showError) {
      this.claimService.updateClaimReport({vehicleType: rawValue});
      this.claimService.save().subscribe(() => {
        this.formNavigationService.navigate(NavigationKey['vehicle-involved']);
      });

    }
  }

  private evaluateShowError() {
    let rawValue = this.radioControl.getRawValue();
    this.showError = rawValue == null;
  }

  setOption(value: string) {
    this.radioControl.patchValue(value);
    this.showError = false
  }
}
